import useCheckPermission from '../hooks/useCheckPermission';
import ContentPage from '../pages/contents/ContentPage';

export const Dashboard = (props: any): JSX.Element => {
  const { checkPermission } = useCheckPermission();

  return <div>{checkPermission(['ViewContent']) && <ContentPage />} </div>;
};
